'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var Highstock = new Class({
	Implements: [Events, Options],

	options: {
		colors: ['#6aade1', '#aca000', '#008c99', '#c03e62', '#494a66', '#ff6a00'],

		containerId: null,

		chart: {
			chart: {
				renderTo: 'chart_container'
			},

			rangeSelector: {
				selected: 5,

				inputStyle: {
					color: '#355672',
					// fontWeight: 'bold',
					fontSize: '13px'
				},

				inputDateFormat: '%m/%d/%Y',
				inputEditDateFormat: '%m/%d/%Y'
			},

			credits: {
				enabled: false
			},

			xAxis: {
				ordinal: false,
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14 //two weeks
			},

			yAxis: {
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					align: 'left',
					x: 0
				},

				min: 0,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				endOnTick: false,
				showLastLabel: true,
				opposite: false
			},

			navigator: {
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 150,
					ordinal: false,
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					}
				},

				series: {
					color: '#008C99'
				}
			},

			plotOptions: {
				series: {
					animation: true
				},

				line: {
					dataGrouping: {
						enabled: false,
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			scrollbar: {
				barBackgroundColor: '#008C99',
				rifleColor: '#fff',
				buttonBackgroundColor: '#008C99',
				buttonArrowColor: '#fff'
			}
		},

		tooltip_title: null
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);

		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var x_label = this._element.getAttribute('data-x-label');
		var y_label = this._element.getAttribute('data-y-label');

		if (x_label && x_label.trim() != '') {
			this.options.chart.xAxis.title.text = x_label;
		}

		if (y_label && y_label.trim() != '') {
			this.options.chart.yAxis.title.text = y_label;
		}

		this._chart_options = document.getElements('.chart_options li');
		this._veil = this._element.getElement('.veil');

		var rpc;
		this.series_options = new Array(this._chart_options.length);

		if (this._chart_options) {
			this._chart_options.each(function (_el, i) {
				if (!_el.hasClass('disabled')) {
					_el.setStyles({
						'color': this.options.colors[i],
						'border-color': this.options.colors[i]
					});
				}
			}.bind(this));

			this.rpcs = [];
			this._chart_options.each(function (e) {
				this.rpcs.push(e.getAttribute('data-rpc'));
			}.bind(this));

			rpc = this.rpcs[0];

			this._chart_options.each(function (e, i) {
				if (!e.hasClass('disabled')) {
					e.addEvent('click', function () {
						if (!e.hasClass('selected')) {
							if (this.waiting) return;

							document.body.style.cursor = 'wait';
							var rpc = e.getAttribute('data-rpc');

							if (rpc && rpc !== '') {
								this.add_series_option(e, i);
							} else {
								this.show_warning();
							}
						} else {
							this.hide_series_option(i);

							e.setStyles({
								'color': this.options.colors[i],
								'background-color': '#fff'
							});
						}
					}.bind(this));
				} else {
					e.addClass('inactive');
				}
			}.bind(this));
		}

		rpc = rpc || this._element.getAttribute('data-rpc');

		if (rpc && rpc !== '') {
			this.rpc_request(rpc, this.post_rpc.bind(this));
		}
	},

	rpc_request: function rpc_request(url, success) {
		var self = this;

		if (this._veil) {
			this._veil.show();
		}

		this.remote = new Remote({
			rpc: url,
			method: 'get',
			onSuccess: success,
			onError: function onError() {
				self.show_warning(true);
			}
		});
	},

	show_warning: function show_warning(permanent_msg) {
		if (!this._err_msg) {
			this._err_msg = new Element('div', { 'class': 'err_msg', 'text': 'No data available. Please try again later.' });
			this._err_msg.inject(this._element, 'before');
		}

		this._err_msg.fade('in');

		if (!permanent_msg) {
			(function () {
				this._err_msg.fade('out');
			}).bind(this).delay(3000);
		}

		this.fireEvent('warning');
	},

	add_series_option: function add_series_option(option, i) {
		var name = option.get('text');

		if (!this.series_options[i]) {
			this.waiting = true;

			this.rpc_request(option.getAttribute('data-rpc'), function () {
				this.series_options[i] = {
					name: name,
					data: this.remote.get_data().data,
					color: this.options.colors[i]
				};

				if (this.chart) {
					this.chart.addSeries(this.series_options[i]);
				}

				option.setStyles({
					'color': '#fff',
					'background-color': this.options.colors[i]
				});

				option.addClass('selected');

				if (this._veil) {
					this._veil.hide();
				}

				this.waiting = false;
			}.bind(this));
		} else {
			this.chart.addSeries(this.series_options[i]);
			option.addClass('selected');

			option.setStyles({
				'color': '#fff',
				'background-color': this.options.colors[i]
			});

			if (this._veil) {
				this._veil.hide();
			}

			this.waiting = false;
		}

		document.body.style.cursor = 'default';
	},

	hide_series_option: function hide_series_option(i) {
		var name = this.series_options[i].name,
		    position;

		if (this.chart) {
			this.chart.series.each(function (e, i) {
				if (e.name === name) position = i;

				return;
			});

			this.chart.series[position].remove();
		}

		this._chart_options[i].removeClass('selected');
	},

	post_rpc: function post_rpc() {
		var data = this.remote.get_data();
		this.sales = this.remote.get_data().sales;

		if (data && data.data && this.remote.get_data().data.length > 1) {
			this.series_options[0] = {
				name: 'All Transactions',
				data: this.remote.get_data().data,
				color: this.options.colors[0]
			};

			if (this._chart_options) {
				this._chart_options[0].addClass('selected');

				this._chart_options[0].setStyles({
					'color': '#fff',
					'background-color': this.options.colors[0]
				});
			}

			this.create_chart();
		} else {
			this._chart_options.getParent().hide();
			this.show_warning(true);
		}

		if (this._veil) {
			this._veil.hide();
		}

		this.waiting = false;
	},

	create_chart: function create_chart() {
		var self = this;
		var series_options = this.series_options.clean();
		var chart_options = this.options.chart;
		var data_type = this.get_data_type();
		var _container = null;
		if (this.options.containerId) {
			_container = document.getElement('#' + this.options.containerId);
		} else {
			_container = document.getElement('.w_bldblimp #chart_container');
		}

		if (!_container) {
			_container = this._element.getElement('#chart_container');
		}

		this.move_rangeselector();

		chart_options = Object.merge(chart_options, {
			chart: {
				renderTo: _container
			},

			series: series_options,

			tooltip: {
				useHTML: true,
				style: {
					padding: '8px'
				},
				formatter: function formatter(e) {
					if (self.sales) {
						var data = self.sales[this.x];
						var content = '';
						var color = this.points[0].series.color;

						var counter = 0;
						Object.each(data, function (row, i) {
							content += row[0];
							if (counter < Object.getLength(data) - 1) {
								content += '<br /><hr style="margin: 10px 0; color: ' + color + ';" />';
							}
							counter++;
						});
					} else {
						var pageTitle = document.getElement('.page_title h1') ? document.getElement('.page_title h1').get('text') : '';
						var _title = self.options.tooltip_title || pageTitle;
						var total_points = this.points.length;
						var content = '';
						content += '<div class="series_name" style="border-bottom-color:' + this.points[0].series.color + '">' + _title + '</div><br/>' + 'Value on ' + '<b>' + Highcharts.dateFormat('%b %e, %Y', this.x) + '</b><br/><br/>';

						if (total_points > 1) {
							content += data_type + ' price / ft<sup>2</sup> of : <br/>';
						}

						this.points.each(function (e, i) {
							var point = e.point;
							var amount = e.point.series.options.data[e.point.index][2] ? ' (' + e.point.series.options.data[e.point.index][2] + ')' : '';

							if (total_points > 1) {
								content += '<span style="color:' + point.series.color + '; margin-left:20px;">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							} else if (self._element.getAttribute('data-price-type') == 'closing') {
								content += data_type + ' closing price of <span style="color:' + point.series.color + '">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							} else {
								content += data_type + ' price / ft<sup>2</sup> of <span style="color:' + point.series.color + '">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							}
						});
					}

					return content;
				}
			},

			yAxis: {
				labels: {
					formatter: function formatter() {
						return '$' + Core.add_commas(this.value);
					}
				}
			}
		});

		this.chart = new Highcharts.StockChart(chart_options, function (chart) {
			setTimeout(function () {
				var _input_group = this._element.getElement('.highcharts-input-group');
				var _inputs = this._element.getElements('input.highcharts-range-selector', '#' + chart.options.chart.renderTo);

				if (_input_group) {
					// this is a workaround. close event from Date Picker widget is triggerred when clicking the input Date
					// need to cancel it.
					_input_group.addEvent('click', function (e) {
						e.stop();
					});
				}

				if (_inputs && _inputs.length > 1) {
					var min_date = new Date().parse(_inputs[0].get('value'));
					var max_date = new Date().parse(_inputs[1].get('value'));
				}

				_inputs.each(function (_el, i) {
					var min = min_date.clone();
					var max = max_date.clone();

					var dp = new Picker.Date(_el, {
						timePicker: true,
						draggable: false,
						minDate: i === 0 ? min : min.increment('day', 15),
						maxDate: i === 1 ? max : max.decrement('day', 15),
						pickOnly: 'days',
						pickerClass: 'datepicker_vista',
						format: "%Y-%m-%d",
						useFadeInOut: true,
						onSelect: function onSelect(dateText, input) {
							input.onchange();
							input.onblur();

							if (i === 0) {
								datepickers[1].options.minDate = dateText.increment('day', 15);
							} else if (i === 1) {
								datepickers[0].options.maxDate = dateText.decrement('day', 15);
							}
						}
					});

					datepickers.push(dp);

					_el.addEvent('focus', function () {
						datepickers.each(function (dp, j) {
							if (i !== j) {
								dp.hide();
							}
						});
					});
				});
			}.bind(this), 0);
		}.bind(this));
	},

	get_data_type: function get_data_type() {
		var rpc_string = this.remote.options.rpc;
		var p = rpc_string.contains('&p=');
		var show = rpc_string.contains('&show');

		if (p || show) {
			if (p) {
				data_type = 'Median';
			}

			if (show) {
				var rpc_string = this.remote.options.rpc;
				var start = rpc_string.indexOf('show');
				var end = rpc_string.lastIndexOf('&');
				var show_param = rpc_string.substring(start, end);
				var data_type = show_param.substring(show_param.indexOf('=') + 1);

				data_type = data_type == 'avg' ? 'Average' : 'Median';
			}

			return data_type;
		}

		data_type = 'Average';

		return data_type;
	},

	move_rangeselector: function move_rangeselector() {
		// To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 10
				});

				leftPosition += this.zoomText.getBBox().width + 20;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	}
});

var datepickers = [];
'use strict';

/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var HoodsAreaMap = new Class({
	Extends: SimpleMap,
	Implements: [Options, Events],

	defer_build: function defer_build() {
		this.parent();
		this.get_data();
	},

	get_data: function get_data() {
		var self = this;
		var opts = this.options;

		if (opts.data && opts.data != '') {
			self.data = opts.data;
			self.process_rpc();
		} else if (self._element.getAttribute('data-rpc')) {
			var url = self._element.getAttribute('data-rpc');

			new Remote({
				rpc: url,
				onSuccess: function onSuccess() {
					self.data = this.get_data();
					self.draw_map();
				}
			});
		} else {
			return;
		}
	},

	process_rpc: function process_rpc() {
		var opts = this.options,
		    data = this.data,
		    self = this;

		if (data.data.hood.length > 0 || data.data.building.length > 0) {
			if (data.data.building.length > 0) {
				this.add_marker({
					lat: data.data.building[0].lat,
					lng: data.data.building[0].lng,
					icon: Res_i + '/w/hoods/bld-markers/' + (data.data.building.length > 100 ? '100+' : data.data.building.length) + '.png',
					bubble: {
						content: data.data.building[0].name + '<span class="legend">Click on marker for more info</span>'
					},
					callbacks: {
						onClick: function onClick() {
							opts.open_blimp(data.data.building[0].url_popup);
						}
					}
				});
			}

			if (data.data.hood.length > 0) {
				data.data.hood.each(function (place) {
					self.add_marker({
						lat: place[0].lat,
						lng: place[0].lng,
						icon: Res_i + '/w/hoods/hood-markers/' + (place.length > 100 ? '100+' : place.length) + '.png',
						bubble: {
							content: place[0].name + '<span class="legend">Click on marker for more info</span>'
						},
						callbacks: {
							onClick: function onClick() {
								opts.open_blimp(place[0].url_popup);
							}
						}
					});
				});
			}

			this.fit_markers();

			(function () {
				this.fireEvent('ready');
			}).bind(this).delay(2000);
		} else {
			this.fireEvent('noData');
		}
	}
});
'use strict';

/*
--- 
description: FED Process
authors: 
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var HoodsHeatMap = new Class({
	Extends: HoodsMap,
	Implements: [Options, Events],

	draw_map: function draw_map() {
		this.parent();

		this.add_heatmap_layer();
	},

	add_heatmap_layer: function add_heatmap_layer() {
		var data = this.data;
		var heatmapData = [];

		data.data.each(function (el) {
			var obj = { location: new google.maps.LatLng(el.lat, el.lng), weight: el.weight };
			heatmapData.push(obj);
		});

		var heatmap = this.heatmap = new google.maps.visualization.HeatmapLayer({
			data: heatmapData,
			radius: data.radius ? data.radius : 20
		});

		// this.change_gradient();
		// this.change_opacity();
		heatmap.setMap(this.map);
	},

	change_gradient: function change_gradient() {
		var gradient = ['rgba(228, 139, 225, 0)', //bkg color
		'rgba(228, 139, 225, 1)', //least intensive color
		'rgba(255, 255, 0, 1)', 'rgba(255, 255, 255, 1)' // most intensive color
		];

		this.heatmap.setOptions({
			gradient: this.heatmap.get('gradient') ? null : gradient
		});
	},

	change_opacity: function change_opacity() {
		this.heatmap.setOptions({ opacity: this.heatmap.get('opacity') ? null : 1.0 });
	}
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var NhStats = new Class({
	Implements: [Options, Events],

	options: {
		type: 2,
		graph_colors: ['#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00'],
		map_zoom: 13,
		map_markers_path: null
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.build();
	},

	build: function build() {
		var self = this;

		this.beds_status = [true, true, true, true, true];

		this.cache = [];

		this.rangeslider = new Rangeslider(this._element.getElement('.w_rangeslider'), {
			title: 'Date Range:',
			onComplete: function onComplete(min, max, min_formatted, max_formatted) {
				self.date_min_formatted = min_formatted || min;
				self.date_max_formatted = max_formatted || max;

				if (this._min_label) {
					self.date_min_formatted = this._min_label.get('text');
				}

				if (this._max_label) {
					self.date_max_formatted = this._max_label.get('text');
				}

				self.date_min = min || this._min_input.get('value');
				self.date_max = max || this._max_input.get('value');

				self.date_max = moment(self.date_max).endOf('month').format('YYYY-MM-DD');

				self.display_period();

				self.filter_data();
				self.apply_data();

				/*---*/
				// to set the bed to be the same as the one in city stats if the user click the series line.
				if (self._element.get('data-bed-id') && self._message.getStyle('display') != 'block') {
					var bed_id = self._element.get('data-bed-id');
					var _bed = document.getElement('.nh_beds');

					if (!_bed) return;

					var _beds = _bed.getElements('li._selected');

					_beds.each(function (_b) {
						if (bed_id.toInt() != 0 && _b.hasClass('_active')) {
							if (!_b.hasClass('beds_' + bed_id)) {
								_b.fireEvent('click');
							}
						}
					});

					self._element.set('data-bed-id', '');
				}

				// var url = window.location.href;

				// if(url.contains('bedrooms=')){
				// 	var start = url.indexOf('bedrooms=');
				// 	var param = url.substring(start);
				// 	var bed_id = param.substr(param.indexOf('=')+1);
				// 	var _bed = document.getElement('.nh_beds');
				// 	var _beds = _bed.getElements('li._selected');

				// 	_beds.each(function(_b){
				// 		if(bed_id.toInt() != 0 && _b.hasClass('_active')){
				// 			if(!_b.hasClass('beds_'+ bed_id)){
				// 				_b.fireEvent('click');
				// 			}
				// 		}
				// 	})
				// }

				/*---*/
			}
		});

		this.mindate_to_compare = this.rangeslider._min_label ? this.rangeslider._min_label.get('text') : this.rangeslider._min_input.get('value');
		this.maxdate_to_compare = this.rangeslider._max_label ? this.rangeslider._max_label.get('text') : this.rangeslider._max_input.get('value');

		if (this._element.getElement('.w_rangeslider_labels')) {
			this.date_min_formatted = this._element.getElement('.w_rangeslider_labels .min').get('text');
			this.date_max_formatted = this._element.getElement('.w_rangeslider_labels .max').get('text');
		} else {
			this.date_min_formatted = this.rangeslider._min_input.get('text');
			this.date_max_formatted = this.rangeslider._max_input.get('text');
		}

		this.type = _typeof(this.options.type) == 'object' ? this.options.type.value : this.options.type;

		this._graph_cont = document.getElement('.w_neighborhoods .graph .graph_container');
		this._chart_cont = document.getElement('.w_neighborhoods .chart .graph_container');
		this._listview_cont = document.getElement('.w_neighborhoods .listview');
		this._areamap_cont = document.getElement('.w_neighborhoods .areamap');
		this._heatmap_cont = document.getElement('.w_neighborhoods .heatmap');

		var _conts = [this._areamap_cont, this._listview_cont, this._chart_cont.getParent('.chart'), this._graph_cont.getParent('.graph'), this._heatmap_cont];

		this._veil = document.getElement('.w_neighborhoods .data_display_veil');
		this._message = document.getElement('.w_neighborhoods .data_display .error');
		this._warning = document.getElement('.w_neighborhoods .data_display .warning').hide();

		this.init_message = this._message.get('text');

		this._header = document.getElement('.ns_header h2');
		this._cats = this._element.getElements('.nh_categories a');

		this._region_styled_select = self._element.getElement('.w_styled_select._regions');
		this._region_select = this._element.getElement('.w_styled_select._regions select');

		this._precise = this._element.getElement('.nh_precise');
		this._beds_cont = this._element.getElement('.nh_beds');
		this._beds_select = self._element.getElement('.w_multiselect._beds');
		this._beds = this._beds_cont.getElements('li');

		this._currency_styled_select = self._element.getElement('.w_styled_select.currency');
		this._currency_select = this._element.getElement('.w_styled_select.currency select');
		this.currency = this._currency_select.getElement(':selected').get('value');
		this._currency_select.addEvent('change', function () {
			self.currency = self._currency_select.getElement(':selected').get('value');
			self.get_data();
		});
		this.currency_symbol = '$';

		if (this._beds_select) {
			this.add_beds_select();
		} else {
			this.add_beds_functionality();
		}

		this._summary = document.getElement('.w_neighborhoods .summary');

		this.cats = this._cats;

		if (this._region_styled_select) {
			this._region_select_options = this._region_select.getElements('option');
			this._cats = this._region_styled_select.getElements('li');
		}

		this._cats.each(function (_el, i) {
			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (self._clicked_cat === _el && e) return;

				if (self._clicked_cat) {
					self._clicked_cat.removeClass('_selected');
					self._clicked_cat.removeClass('_loading');
				}

				self._clicked_cat = _el;
				self.region_id = self._region_select_options ? self._region_select_options[i].get('value') : _el.get('data-region');

				if (!this._region_styled_select) {
					_el.addClass('_selected');

					var nh = self._clicked_cat.get('text').trim();

					self._precise.getElement('h3').set('text', nh + (nh.length > 15 ? ' nbrhds' : ' neighborhoods'));

					self.current_nh = _el._precise_select ? _el._precise_select.getElement('.monitor').get('text') : 'this neighborhood';
				}

				if (_el.ss) {
					_el.ss.fireEvent('change');
				}

				self.set_new_precise_select(_el);

				self.set_header(self.current_nh);
			}.bind(this));
		}.bind(this));

		//this.set_active_region();

		this._menu_togglers = document.getElements('.w_neighborhoods .nh_tools a');
		this._current_menu_toggler = this._menu_togglers[0];

		this._menu_togglers.each(function (_el, i) {
			_el.data_changed = i != 0;
			_el.beds_status = [true, true, true, true, true];
			_el._cont = _conts[i];

			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (_el !== self._current_menu_toggler) {
					self.toggle_menu(_el);
				}
			});
		});
	},

	display_period: function display_period() {
		var date_min = this.date_min_formatted || this.date_min;
		var date_max = this.date_max_formatted || this.date_max;

		var period = '(' + date_min + ' - ' + date_max + ')';

		if (date_min == date_max) {
			period = '( ' + date_max + ' )';
		}

		if (date_max == this.maxdate_to_compare) {
			var diff = Date.parse(this.date_min).diff(Date.parse('28th'), 'month');

			if (diff <= 12) {
				period = '(past ' + diff + ' month' + (diff == 1 ? ')' : 's)');
			}

			if (diff == 0) {
				period = '( ' + date_max + ' )';
			}
		}

		this._summary.getElement('._period').set('text', period);
	},

	get_data: function get_data() {
		var self = this;

		if (this._current_nh.data && this._current_nh.data[this.type] && this._current_nh.data[this.type][this.currency] && this._current_nh.data[this.type][this.currency] != 'waiting' && this._current_nh.data[this.type][this.currency] != 'error') {
			this.rangeslider.fireEvent('complete');

			return;
		}

		// if User click a hood series from CityStats : Apartment prices by Region Chart,
		// Apply the same criteria to get the correct data of the selected hood from the previous page
		var crNhStatsCriteria = Cookie.read('crNhStatsCriteria');
		if (crNhStatsCriteria) {
			crNhStatsCriteria = JSONMOO.decode(crNhStatsCriteria);

			this.current_nh_id = crNhStatsCriteria.hood;
			this.region_id = crNhStatsCriteria.region;
			this.type = crNhStatsCriteria.type;
			this.currency = crNhStatsCriteria.currency;
		}

		var hood_string = '';

		if (this.current_nh_id == 0) {} else {
			hood_string = '&hood=' + this.current_nh_id;
		}

		var rpc = self._clicked_cat.getAttribute('data-rpc');

		if (this._region_styled_select) {
			rpc = this._region_styled_select.get('data-rpc') + '&region=' + this.region_id;
		}

		rpc += '&type=' + this.type + hood_string + '&currency=' + self.currency;

		this.latest_rpc = rpc;

		self._current_nh.data = self._current_nh.data || {};

		var type = self.type;

		self._current_nh.data[type] = self._current_nh.data[type] || {};

		if (self._current_nh.data[type][self.currency] == 'waiting') return;

		self._current_nh.data[type][self.currency] = 'waiting';

		this._veil.show();
		this.rangeslider.disable();

		var nh = self._current_nh;
		var cc = self._clicked_cat;

		if (this.remote) {
			this.remote.cancel();
			// delete the waiting status in case of cancel
			if (self.previous_current_nh && self.previous_current_nh.data) {
				delete self.previous_current_nh.data[type][self.currency];
			}
		}

		this.remote = new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				nh.data[type][self.currency] = this.get_data();
				cc.removeClass('_loading');

				if (self.latest_rpc == this.options.rpc) {
					self.rangeslider.fireEvent('complete');
				}
			}
		});

		this._summary.addClass('_loading');
		this.remote._clicked_cat = this._clicked_cat;
		this.remote._clicked_cat.addClass('_loading');
	},

	filter_data: function filter_data() {
		var self = this;
		this.sorted_data = this._current_nh.data[this.type][this.currency].sales;

		Object.each(this.sorted_data, function (el, i) {
			var display_by_beds = false;

			el.each(function (e) {
				var date = e.sale_date_unformatted;

				if (date > self.date_max || date < self.date_min) {
					e.display = false;
				} else {
					e.display = true;
					display_by_beds = true;
				}
			});

			if (display_by_beds) {
				self._beds[i - 10].addClass('_active');

				if (self.beds_status[i - 10]) {
					self._beds[i - 10].addClass('_selected');
				}
			} else {
				self._beds[i - 10].removeClass('_active').removeClass('_selected');
			}
		});
	},

	apply_data: function apply_data() {
		var current_display = this._current_menu_toggler.getAttribute('data-element');

		this.currency_symbol = Core.get_html_text(this._current_nh.data[this.type][this.currency].currency_symbol);

		if (current_display == 'graph') {
			this.display_graph();
		} else if (current_display == 'chart') {
			this.display_chart();
		} else if (current_display == 'listview') {
			this.display_listview();
		} else if (current_display == 'areamap') {
			this.display_areamap();
		} else if (current_display == 'heatmap') {
			this.display_heatmap();
		}

		this.rangeslider.enable();

		this.set_summary();
	},

	add_beds_select: function add_beds_select() {
		var self = this;

		this._element.getElement('.w_styled_select._beds').hide();

		this._beds_select.show();

		this.beds_multiselect = new Multiselect(this._beds_select, {
			text_input: false,
			close_button: false,
			equality: true,
			add_tiles: false,
			onClick: function onClick(e, _el) {
				var id = _el.get('data-id');
				var dbb = _el.hasClass('_selected');
				self.beds_status[id - 10] = dbb;

				self.sorted_data[id].each(function (el) {
					el.display_by_beds = dbb;
				});

				var current_display = self._current_menu_toggler.getAttribute('data-element');

				if (current_display == 'graph') {
					self.update_highchart_series(id, dbb, 'graph');
				} else if (current_display == 'chart') {
					self.update_highchart_series(id, dbb, 'chart');
				} else if (current_display == 'listview') {
					self.display_listview();
				} else if (current_display == 'areamap') {
					self.display_areamap();
				} else if (current_display == 'heatmap') {
					self.display_heatmap();
				}

				self.set_summary();
			}
		});

		this.beds_multiselect.update_monitor();
	},

	add_beds_functionality: function add_beds_functionality() {
		var self = this;

		this._beds.each(function (_el, i) {
			_el.addEvents({
				'click': function click() {
					if (_el.hasClass('_active')) {
						_el.toggleClass('_selected');
						var dbb = _el.hasClass('_selected');
						self.beds_status[i] = dbb;

						self.sorted_data[i + 10].each(function (el) {
							el.display_by_beds = dbb;
						});

						var current_display = self._current_menu_toggler.getAttribute('data-element');

						if (current_display == 'graph') {
							self.update_highchart_series(i + 10, dbb, 'graph');
						} else if (current_display == 'chart') {
							self.update_highchart_series(i + 10, dbb, 'chart');
						} else if (current_display == 'listview') {
							self.display_listview();
						} else if (current_display == 'areamap') {
							self.display_areamap();
						} else if (current_display == 'heatmap') {
							self.display_heatmap();
						}

						self.set_summary();

						_el.fireEvent('mouseleave');
					}
				},

				'mouseenter': function mouseenter() {
					_el.addClass('_hovered');
				},

				'mouseleave': function mouseleave() {
					_el.removeClass('_hovered');
				}
			});
		});
	},

	toggle_menu: function toggle_menu(_el) {
		var self = this;
		this._menu_togglers.each(function (_e) {
			if (_e !== _el) {
				_e.removeClass('_active');
				_e._cont.hide();
			}
		});

		this.beds_status.each(function (el, i) {
			self._current_menu_toggler.beds_status[i] = el;
		});

		_el.addClass('_active');
		_el._cont.show();

		_el.data_changed = false;
		this._current_menu_toggler = _el;

		this.apply_data();
	},

	mark_menu_togglers: function mark_menu_togglers() {
		this._menu_togglers.each(function (_el) {
			if (!_el.hasClass('_active')) {
				_el.data_changed = true;
			} else {
				_el.data_changed = false;
			}
		});
	},

	set_summary: function set_summary() {
		var self = this;
		var total_sales = 0;
		var avg_ppsqft = 0;
		var avg_price = 0;
		var median_price = 0;
		var median_prices_array = [];

		var most_expensive, least_expensive;

		var cs = this.currency_symbol;

		if (this.sorted_data) {
			this.beds_status.each(function (el, i) {
				if (el && self.sorted_data[i + 10] && self.sorted_data[i + 10]) {
					self.sorted_data[i + 10].each(function (e) {
						if (e.display) {
							var price = (e.sale_price || 0).toFloat();

							total_sales++;
							avg_ppsqft += (e.ppsqft || 0).toFloat();
							avg_price += price;
							median_prices_array.push(price);

							if (!most_expensive || price > most_expensive.sale_price.toFloat()) {
								most_expensive = e;
							}

							if (!least_expensive || price < least_expensive.sale_price.toFloat()) {
								least_expensive = e;
							}
						}
					});
				}
			});

			if (total_sales > 0) {
				avg_ppsqft /= total_sales;
				avg_price /= total_sales;

				if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
					if (avg_ppsqft > 0) avg_ppsqft = Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
					if (avg_price > 0) avg_price = Core.add_commas(avg_price.round(0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
				} else {
					if (avg_ppsqft > 0) avg_ppsqft = cs + Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0));
					if (avg_price > 0) avg_price = cs + Core.add_commas(avg_price.round(0));
				}

				if (median_prices_array.length > 0) {
					median_prices_array = median_prices_array.sort(function (a, b) {
						return a - b;
					});

					if (median_prices_array.length % 2 == 0) {
						median_price = ((median_prices_array[median_prices_array.length / 2] + median_prices_array[median_prices_array.length / 2 - 1]) / 2).round(0);
					} else {
						median_price = median_prices_array[(median_prices_array.length / 2).floor()].round(0);
					}

					if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
						median_price = Core.add_commas(median_price) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
					} else {
						median_price = cs + Core.add_commas(median_price);
					}
				}

				if (total_sales > 500) {
					self._warning.show();
				} else {
					self._warning.hide();
				}
			}
		}

		this._summary.getElement('#total_sales').set('html', total_sales);

		var _avg_price_ft = this._summary.getElement('#avg_price_ft');
		_avg_price_ft.set('html', avg_ppsqft);

		if (_avg_price_ft.get('text').length > 8) {
			_avg_price_ft.addClass('_small');
		} else {
			_avg_price_ft.removeClass('_small');
			_avg_price_ft.removeClass('_supersmall');
		}

		if (_avg_price_ft.get('text').length > 11) {
			_avg_price_ft.addClass('_supersmall');
		}

		var _avg_price = this._summary.getElement('#avg_price');
		_avg_price.set('html', avg_price);

		if (_avg_price.get('text').length > 8) {
			_avg_price.addClass('_small');
		} else {
			_avg_price.removeClass('_small');
			_avg_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_avg_price.addClass('_supersmall');
		}

		var _med_price = this._summary.getElement('#med_price');
		_med_price.set('html', median_price);

		if (_med_price.get('text').length > 8) {
			_med_price.addClass('_small');
		} else {
			_med_price.removeClass('_small');
			_med_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_med_price.addClass('_supersmall');
		}

		this._summary.removeClass('_loading');

		if (most_expensive) {
			var me = '<strong>Most Expensive</strong><br>' + '<a href="' + most_expensive.url_sold + '">' + (most_expensive.name || most_expensive.display_name || most_expensive.street_address) + ', #' + most_expensive.unit + '</a><br/>' + most_expensive.bedroom.split('room').join('') + ' | ' + most_expensive.sale_price_format + '<br>' + most_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + most_expensive.sale_date + '</span>';

			this._most_expensive = this._summary.getElement('#most_exp');
			this._most_expensive.set('html', me);

			this._summary.getElement('#most_exp').show();
		} else {
			this._summary.getElement('#most_exp').hide();
		}

		if (least_expensive) {
			var le = '<strong>Least Expensive</strong><br>' + '<a href="' + least_expensive.url_sold + '">' + (least_expensive.name || least_expensive.display_name || least_expensive.street_address) + ', #' + least_expensive.unit + '</a><br/>' + least_expensive.bedroom.split('room').join('') + ' | ' + least_expensive.sale_price_format + '<br>' + least_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + least_expensive.sale_date + '</span>';

			this._least_expensive = this._summary.getElement('#least_exp');
			this._least_expensive.set('html', le);

			this._summary.getElement('#least_exp').show();
		} else {
			this._summary.getElement('#least_exp').hide();
		}
	},

	set_new_precise_select: function set_new_precise_select(_el) {
		var self = this;
		var _ss = this._precise.getElement('.w_styled_select');

		if (_ss) _ss.dispose();

		if (!_el._precise_select) {
			var config;

			try {
				var data = (_el.getNext('.hoods') || _el.getElement('.hoods')).get('html');
				config = JSONMOO.decode(data, false);
			} catch (e) {}

			if (typeOf(config) == 'object') {
				_el.hoods = config;

				var _select = _el._hood_select = new Element('select');

				Object.each(_el.hoods, function (el, i) {
					new Element('option', { 'text': el, 'data-hood': i }).inject(_select);
				});

				_el._precise_select = new Element('div', { 'class': 'w_styled_select' }).adopt(_select);

				this._precise.adopt(_el._precise_select);

				_el.ss = this.styledselect = new StyledSelect(_el._precise_select);

				this.fireEvent('nhSet', [_el._precise_select]);

				if (this.current_nh_id) {
					var _ul = this._region_styled_select ? this._region_styled_select.getElement('ul') : this._element.getElement('.nh_categories ul');
					_ul.setAttribute('data-hood-selected', self.current_nh_id);
				}

				this.set_active_hood(_el._precise_select);

				_el.ss.addEvent('change', function () {
					self.current_nh = this.text;

					self.set_header(this.text);

					var _selected_option = this._select.getElement(':selected');

					if (!_selected_option) {
						_select.getElements('option').each(function (_option) {
							if (_option.get('text') == self.current_nh) {
								_selected_option = _option;
							}
						});
					}

					self.previous_current_nh = self._current_nh;
					self.current_nh_id = _selected_option.getAttribute('data-hood');
					self._current_nh = this._selected;

					self.get_data();

					if (self.graph && self._current_nh.data[self.type][self.currency] != 'waiting' && self._current_nh.data[self.type][self.currency] != 'error') {
						self.mark_menu_togglers();
					}
				});

				_el.ss.fireEvent('change');
			} else {
				this._precise.hide();
			}
		} else {
			this._precise.adopt(_el._precise_select);
		}
	},

	set_active_region: function set_active_region() {
		var self = this;

		this._cats_ul = self._element.getElement('.nh_categories ul') || this._region_styled_select.getElement('ul');
		var active_region = this._cats_ul.get('data-region-selected');
		if (active_region) {

			this._cats.each(function (_cat, i) {

				if (this._region_styled_select) {
					if (this._region_select_options[i].get('value') == active_region) {
						_cat.fireEvent('click');
					}
				} else {
					if (_cat.get('data-region') == active_region) {
						_cat.fireEvent('click');
					}
				}
			}.bind(this));
		} else {
			this._cats[0].fireEvent('click');
		}
	},

	set_active_hood: function set_active_hood(_precise_select) {
		var self = this;
		this._cats_ul = self._element.getElement('.nh_categories ul') || this._region_styled_select.getElement('ul');

		var active_hood = this._cats_ul.get('data-hood-selected');
		var _options = _precise_select.getElements('option');

		if (active_hood) {
			_options.each(function (_option, i) {
				if (_option.get('data-hood') == active_hood) {
					var _opts = _precise_select.getElements('.option');
					_opts[i].fireEvent('click');
				}
			}.bind(this));
		}
	},

	set_header: function set_header(text) {
		if (!this._header) return;
		this._header.set('html', text + ' Sales Summary');
	},

	display_chart: function display_chart() {
		var self = this;
		this.display_message(false);

		var series = [];
		var color = 0;

		var data = {
			10: this.sorted_data[10],
			11: this.sorted_data[11],
			12: this.sorted_data[12],
			13: this.sorted_data[13],
			14: this.sorted_data[14]
		};

		Object.each(data, function (el, i) {
			if (!el || el.length == 0) return;

			var data_series = [];

			Object.each(el, function (e) {
				if (!e.display) return;

				var date = new Date(e.sale_date_unformatted).getTime();

				data_series.push([date, e.ppsqft, e.tooltip, e.url_sold]);
			});

			self.sort(data_series);

			if (data_series.length > 0) {
				series.push({
					name: i,
					color: self.options.graph_colors[color],
					data: data_series
				});
			}

			color++;
		});

		this.cache = series;

		if (this.chart) {
			this.reset_highchart(series, 'chart');
		} else {
			this.move_rangeselector();
			this.get_rangedate();

			this.create_chart(series);

			this.set_rangeselector();

			this.filter_data(); //causes infinite recursion
		}

		this._veil.hide();
	},

	create_chart: function create_chart(series) {
		var self = this;

		if (series.length > 0) {
			this.chart = new Highcharts.StockChart({
				chart: {
					renderTo: self._chart_cont,
					type: 'spline',
					backgroundColor: '#ebebeb',
					marginTop: 25
				},

				series: series,

				title: {
					useHTML: true,
					text: null,
					x: 25,
					margin: 0,
					align: 'left',
					style: {
						color: '#ccc',
						font: '11px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif',
						fontWeight: 'bold'
					}
				},

				subtitle: {
					text: null
				},

				rangeSelector: {
					enabled: false
				},

				credits: {
					enabled: false
				},

				xAxis: {
					type: 'datetime',
					title: {
						text: null
					},
					minRange: 3600000 * 24 * 14, //two weeks
					labels: {
						style: {
							color: '#666'
						}
					}
				},

				yAxis: {
					plotLines: [{
						value: 0,
						width: 2,
						color: '#666'
					}],

					title: {
						text: null,
						x: -5,
						style: {
							color: '#666'
						}
					},

					labels: {
						align: 'left',
						style: {
							color: '#666'
						},
						x: 0,
						formatter: function formatter() {
							return self.currency_symbol + Core.add_commas(this.value);
						}
					},
					gridLineWidth: 1,
					gridLineDashStyle: 'dash',
					gridLineColor: '#666',
					endOnTick: false,
					showLastLabel: true,
					minPadding: 0,
					opposite: false
				},

				navigator: {
					enabled: false
				},

				plotOptions: {
					series: {
						animation: true,
						cursor: 'pointer',
						point: {
							events: {
								click: function click(e) {
									var index;

									if (this.dataGroup) {
										index = this.dataGroup.start;
									} else {
										index = this.index;
									}

									var url = this.series.options.data[index][3];

									if (url) {
										window.location = url;
									}

									self.fireEvent('seriesClick');
								}
							}
						},
						states: {
							hover: {
								lineWidthPlus: 0
							}
						}
					},

					line: {
						dataGrouping: {
							// smoothed: true,
							groupPixelWidth: 5,
							approximation: 'open',
							dateTimeLabelFormats: {
								day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
								week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
							}
						},
						lineWidth: 3,

						states: {
							hover: {
								lineWidthPlus: 0
							}
						},

						marker: {
							enabled: false,
							states: {
								hover: {
									enabled: true
								}
							}
						}
					}
				},

				tooltip: {
					useHTML: true,
					valueDecimals: 0,
					shared: false,
					crosshairs: false,
					borderWidth: 2,
					style: {
						width: '300px'
					},
					formatter: function formatter() {
						var index;
						if (this.point.dataGroup) {
							index = this.point.dataGroup.start;
						} else {
							index = this.point.index;
						}

						var content = this.point.series.options.data[index][2];

						if (this.point.dataGroup && this.point.dataGroup.length > 1) {
							content += '<br><br><i class="note">Note: This is an Average Closing Price.</i>';
						}

						return content;
					}
				},

				scrollbar: {
					enabled: false
					// barBackgroundColor: '#bbb',
					// barBorderColor: '#fff',
					// rifleColor: '#fff',
					// buttonBackgroundColor: '#bbb',
					// buttonArrowColor: '#666',
					// buttonBorderColor: '#fff',
					// trackBackgroundColor: '#bbb'
				}
			});
		} else {
			this.display_message(true);
		}

		this._veil.hide();
	},

	display_graph: function display_graph() {
		var self = this;
		this.display_message(false);

		var series = [];
		var color = 0;

		var data = {
			10: this.sorted_data[10],
			11: this.sorted_data[11],
			12: this.sorted_data[12],
			13: this.sorted_data[13],
			14: this.sorted_data[14]
		};

		Object.each(data, function (el, i) {
			if (el && el.length > 0) {
				var data_series = [];

				Object.each(el, function (e) {
					if (e.display) {
						data_series.push([e.x, e.y, e.tooltip, e.url_sold]);
					}
				});

				if (data_series.length > 0) {
					series.push({
						name: i,
						color: self.options.graph_colors[color],
						data: data_series,
						marker: {
							symbol: 'circle',
							radius: 8
						}
					});
				}
			}

			color++;
		});

		this.cache = series;

		if (this.graph) {
			this.reset_highchart(series, 'graph');
		} else {
			this.create_graph(series);
			this.filter_data(); //causes infinite recursion
		}

		this._veil.hide();
	},

	create_graph: function create_graph(series) {
		var self = this;

		if (series.length > 0) {
			this.graph = new Highcharts.Chart({
				chart: {
					animation: false,
					renderTo: self._graph_cont,
					type: 'scatter',
					zoomType: 'xy',
					plotBackgroundColor: '#ebebeb',
					backgroundColor: '#ebebeb',
					// marginTop: 20,
					marginBottom: 42,
					marginLeft: 14,
					ignoreHiddenSeries: true,

					resetZoomButton: {
						theme: {
							fill: '#585858',
							stroke: 'silver',
							style: {
								color: '#fff'
							},
							r: 0,
							states: {
								hover: {
									fill: '#41739D',
									style: {
										color: 'white'
									}
								}
							}
						}
					}
				},

				series: series,

				credits: {
					enabled: false
				},

				title: {
					text: null
				},

				xAxis: {
					type: self._current_nh.data[self.type][self.currency].x.type,
					minPadding: 0.1,
					gridLineWidth: 1,
					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',
					// min: 100,
					title: {
						text: '<span style="margin-bottom:3px;">' + self._current_nh.data[self.type][self.currency].x.label + '</span>',
						margin: 3,
						style: {
							color: '#666'
						}
					},
					labels: {
						useHTML: true,
						overflow: 'justify',
						formatter: function formatter() {
							return Core.add_commas(this.value) + ' ft<sup>2</sup>';;
						},
						style: {
							color: '#666',
							fontWeight: 'normal'
						}
					}
				},

				yAxis: {
					type: self._current_nh.data[self.type][self.currency].y.type,
					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',

					showFirstLabel: true,
					showLastLabel: false,

					minPadding: 0.05,
					maxPadding: 0,

					title: {
						text: self._current_nh.data[self.type][self.currency].y.label,
						margin: 3,
						style: {
							color: '#666'
						}
					},
					labels: {
						align: 'left',
						x: 3,
						y: -4,
						formatter: function formatter() {
							if (self.currency.toLowerCase() == 'xau' || self.currency.toLowerCase() == 'rub') {
								return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol.toLowerCase();
							} else {
								return self.currency_symbol + Highcharts.numberFormat(this.value, 0);
							}
						},
						style: {
							color: '#666',
							fontWeight: 'normal',
							whiteSpace: 'nowrap'
						}
					}
				},

				tooltip: {
					formatter: function formatter() {
						if (!this.series.visible) {
							return false;
						} else {
							this.series.zIndex = 1;
						}

						var index;
						if (this.point.dataGroup) {
							index = this.point.dataGroup.start;
						} else {
							index = this.point.index;
						}

						var content = this.point.series.options.data[index][2];

						return content;
					},
					snap: 30,
					useHTML: true
				},

				legend: {
					enabled: false
				},

				plotOptions: {
					scatter: {
						marker: {
							radius: 6,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)'
								}
							}
						},
						states: {
							hover: {
								marker: {
									enabled: false
								}
							}
						}
					},

					series: {
						animation: false,
						cursor: 'pointer',
						point: {
							events: {
								click: function click(e) {
									self._veil.show();

									var index;

									if (this.dataGroup) {
										index = this.dataGroup.start;
									} else {
										index = this.index;
									}

									var url = this.series.options.data[index][3];

									if (url) {
										window.location = url;
									}

									self.fireEvent('seriesClick');
								},
								mouseOver: function mouseOver() {
									if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
										if (!this.button) {
											var index;

											if (this.dataGroup) {
												index = this.dataGroup.start;
											} else {
												index = this.index;
											}

											this.button = new Element('a', { 'class': 'button details', 'href': this.series.options.data[index][3], 'text': 'Listing Details' });
										}

										self._graph_cont.adopt(this.button);
									}
								},

								mouseOut: function mouseOut() {
									if (this.button) {
										this.button.dispose();
									}
								}
							}
						}
					}
				}
			});
		} else {
			this.display_message(true);
		}

		this._veil.hide();
	},

	reset_highchart: function reset_highchart(series, type) {
		var self = this;
		var active_chart = this.chart;

		if (type == 'graph') {
			active_chart = this.graph;
		}

		if (series.length > 0) {
			var length;
			if (Core.is_ie9()) {
				while (active_chart.series.length > 0) {
					active_chart.series[0].remove(true);
				}
			} else {
				length = active_chart.series.length;
				for (var i = 0; i < length; i++) {
					active_chart.series[0].remove(false);
				}

				series.each(function (el) {
					active_chart.addSeries(el);
				});
			}

			this.beds_status.each(function (el, i) {
				self.update_highchart_series(i + 10, el, type);
			});

			active_chart.yAxis[0].setTitle({
				text: self._current_nh.data[self.type][self.currency].y.label
			});
		} else {
			this.display_message(true);
		}
	},

	update_highchart_series: function update_highchart_series(id, turn_on, type) {
		var series;
		var active_chart = this.chart;
		this._hidden_series;

		if (type == 'graph') {
			active_chart = this.graph;
		}

		active_chart.series.each(function (el) {
			if (el.name == id) {
				series = el;
				return;
			}
		});

		if (!Core.is_ie9() && !series) {
			return;
		}

		if (turn_on && series && !series.visible) {
			series.show();
		} else if (turn_on && Core.is_ie9()) {
			var found = null;
			this.cache.each(function (s) {
				if (s.name == id) {
					found = s;
				}
			});
			active_chart.addSeries(found);
		} else if (!turn_on && series && series.visible) {
			//series.zIndex = 0;
			//console.log(series);
			//console.log(series.cursor);
			//series.cursor = null;
			//series.enableMouseTracking = false;
			if (Core.is_ie9()) {
				series.remove();
				active_chart.redraw();
			} else {
				series.hide();
			}
		}
	},

	display_areamap: function display_areamap() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
				});
			}
		});

		if (!this.areamap) {
			this._veil.show();

			this.create_areamap(data);
		} else {
			this.reset_areamap(data);
		}
	},

	create_areamap: function create_areamap(data) {
		var self = this;

		if (data.length > 0) {

			var areamap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				markers_path: this._current_nh ? this._current_nh.data[this.type][this.currency].map_markers_path : this.options.map_markers_path,
				data: data
			};

			this.areamap = new NhStatsAreaMap(this._areamap_cont, {
				min_zoom: 12,
				data: areamap_data,
				// onNoData: function(){ self.display_message(true); },
				open_blimp: function open_blimp(url) {
					self._veil.show();

					var blimp;

					Blimp.instances.each(function (el) {
						if (el.options.rpc_url == url) {
							blimp = el;

							return;
						}
					});

					if (!blimp) {
						blimp = new BlimpExt(null, {
							draggable: true,
							show_veil: true,
							onPostRpc: function onPostRpc() {
								new BldBlimp(this);
								self._veil.hide();

								self.fireEvent('seriesClick');
							},
							rpc_url: url
						});
					}

					blimp._link.fireEvent('click');
				}
			});

			this.areamap.addEvent('ready', function () {
				self._veil.hide();
			});
		} else {
			this.display_message(true);
		}
	},

	reset_areamap: function reset_areamap(sorted_data) {
		if (sorted_data.length > 0) {
			var sorted_data = sorted_data || Object.clone(this.sorted_data);

			this._beds.each(function (_el) {
				sorted_data.each(function (el) {
					el.display_on_map = _el.hasClass('_selected');
				});
			});

			if (!this.areamap) {
				this.create_areamap();
				return;
			}

			var areamap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				markers_path: this._current_nh ? this._current_nh.data[this.type][this.currency].map_markers_path : this.options.map_markers_path,
				data: sorted_data
			};

			this.areamap.data = areamap_data;
			this.areamap.reset_map();

			this._veil.hide();
		} else {
			this.display_message(true);
		}
	},

	display_heatmap: function display_heatmap() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
				});
			}
		});

		if (!this.heatmap) {
			this._veil.show();

			this.create_heatmap(data);
		} else {
			this.reset_heatmap(data);
		}
	},

	create_heatmap: function create_heatmap(data) {
		if (data.length > 0) {
			var self = this;

			var heatmap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				radius: 15,
				opacity: this._current_nh ? this._current_nh.data[this.type][this.currency].heatmap_opacity : this.options.map_markers_path,
				data: data
			};

			this.heatmap = new NhStatsHeatMap(self._heatmap_cont, {
				data: heatmap_data,
				// onNoData: function(){ self.show_error(_el); },
				onReady: function onReady() {
					self._veil.hide();
				}
			});
		} else {
			this.display_message(true);
		}
	},

	reset_heatmap: function reset_heatmap(sorted_data) {
		var sorted_data = sorted_data || Object.clone(this.current_sorted_data);

		this._beds.each(function (_el) {
			sorted_data.each(function (el) {
				el.display_on_map = _el.hasClass('_selected');
			});
		});

		if (!this.heatmap) {
			this.create_heatmap(sorted_data);
			return;
		}

		var heatmap_data = {
			zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
			radius: 15,
			opacity: this._current_nh ? this._current_nh.data[this.type][this.currency].heatmap_opacity : this.options.map_markers_path,
			data: sorted_data
		};

		this.heatmap.data = heatmap_data;
		this.heatmap.add_heatmap_layer();
	},

	display_listview: function display_listview() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
					e.bedroom_id = i;
				});
			}
		});

		this.create_listview(data);
	},

	create_listview: function create_listview(data) {
		var self = this;

		this._veil.show();

		self._listview_cont.empty();
		self._trs = [];

		var _divtable = new Element('div', { 'class': 'w_divtable clearfix' });
		var _thead = '<div class="thead">' + '<div class="tr">' + '<div class="th building_name">Building / Address</div>' +
		//'<div class="th size">size</div>' +
		'<div class="th closing_price">Closing Price</div>' + '<div class="th closing_date"> Closing Date</div>' + '</div>' + '</div>';

		_divtable.set('html', _thead);

		var _tbody = new Element('div', { 'class': 'tbody w_styled_scroll' }).inject(_divtable);
		var nothing_to_show = true;

		var sorted_by_date = self.sort_by_date(data);

		sorted_by_date.each(function (e, i) {
			if (!e.display) return;

			nothing_to_show = false;

			var color;

			switch (e.bedroom_id.toInt()) {
				case 10:
					color = 0;
					break;
				case 11:
					color = 1;
					break;
				case 12:
					color = 2;
					break;
				case 13:
					color = 3;
					break;
				default:
					color = 4;
			}

			var _tr = new Element('div', {
				'class': 'tr',
				'data-href': e.url_sold,
				styles: {
					'border-left': '6px solid ' + self.options.graph_colors[color]
				}
			}).inject(_tbody);

			_tr.addEvent('click', function () {
				self.fireEvent('seriesClick');
			});

			var _td_building = new Element('.td.building_name');
			var _td_closing_price = new Element('.td.closing_price');
			var _td_closing_date = new Element('.td.closing_date');

			var building_text = '<span>' + (e.name || e.street_address) + ', </span><span class="unit"> Apt ' + e.unit + '</span><br>' + (e.name != null ? e.street_address : '');

			var closing_price_text = '<span>' + e.sale_price_format + '</span><br> Approx. ' + e.ppsqft_format + ' / ft <sup>2</sup>';
			var closing_date_text = '<span>' + e.sale_date + '</span>';

			_td_building.set('html', building_text).inject(_tr);
			_td_closing_price.set('html', closing_price_text).inject(_tr);
			_td_closing_date.set('html', closing_date_text).inject(_tr);

			self._trs.push(_tr);
		});

		if (!nothing_to_show) {
			_divtable.inject(self._listview_cont);
			self._listview_cont.show();

			new Divtable(_divtable, { 'zebra_order': 'odd' });

			if (self._trs.length > 9) {
				_divtable.addClass('on_scroll');
				new StyledScroll(_tbody, { type: 'v', max_height: self.set_max_height() });
			}
		} else {
			self._listview_cont.hide();
			self.display_message(true);
		}

		self._veil.hide();
	},

	sort_by_date: function sort_by_date(data) {
		var sorted_by_date = data.sort(function (a, b) {
			return new Date(a.sale_date).set({ sec: 0, ms: 0 }).format("%s") > new Date(b.sale_date).set({ sec: 0, ms: 0 }).format("%s") ? -1 : 1;
		});

		return sorted_by_date;
	},

	set_max_height: function set_max_height() {
		var self = this;
		var max_height = 0;

		self._trs.each(function (_tr, i) {
			if (i < 10) {
				max_height += _tr.getComputedSize().height; //_tr.offsetHeight;//_tr.getSize().y
			}
		});

		return max_height + 20;
	},

	display_message: function display_message(show) {
		var _cont;

		this._menu_togglers.each(function (_el) {
			if (_el.hasClass('_active')) {
				_cont = _el._cont;
				return;
			}
		});

		if (show) {
			this._warning.hide();
			var message = 'No data available for ' + (this.current_nh && this.current_nh.toLowerCase() != 'all' ? this.current_nh : this._clicked_cat.get('text')) + '<br/>for the period of ' + this.date_min_formatted + ' - ' + this.date_max_formatted + '<br/>Try to increase the date range.';

			this._message.set('html', message);

			_cont.hide();
			this._veil.hide();
			this._message.show();
			this.message_displayed = true;
		} else {
			_cont.show();
			this._message.hide();
			this.message_displayed = false;
		}
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    topPosition = this.chart.plotTop - 25,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 200,
					y: topPosition
				});

				leftPosition += this.zoomText.getBBox().width + 200;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 14
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	},

	get_rangedate: function get_rangedate() {
		var url = new URI(window.location.href);
		if (url.getData('date_from') && url.getData('date_to')) {
			this.min_date = url.getData('date_from');
			this.max_date = url.getData('date_to');
		}
	},

	set_rangeselector: function set_rangeselector() {
		var url = new URI(window.location.href);
		if (url.getData('date_from') && url.getData('date_to')) {
			this.chart.xAxis[0].setExtremes(new Date(url.getData('date_from')), new Date(url.getData('date_to')));
		}
	},

	sort: function sort(series) {
		series.sort(function (a, b) {
			if (a[0] < b[0]) return -1;
			if (a[0] > b[0]) return 1;
			return 0;
		});

		// return series;
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var NhStatsAreaMap = new Class({
	Extends: HoodsAreaMap,
	options: {
		use_marker_path: null
	},

	get_data: function get_data() {
		var self = this;
		if (self.options.data != '') {
			self.data = self.options.data;
			self.process_rpc();
		} else {
			return;
		}
	},

	process_rpc: function process_rpc() {
		var opts = this.options,
		    data = this.data,
		    self = this;

		var new_data = {};

		data.data.each(function (el) {
			if (!new_data[el.building_id]) {
				new_data[el.building_id] = [];
			}

			if (el.display) {
				new_data[el.building_id].push(el);
			}
		});

		var num_of_markers = 0;

		Object.each(new_data, function (place) {
			if (place.length > 0) {

				if (!self.in_new_york(place[0].lat, place[0].lng)) return;

				var icon;

				if (self.options.use_marker_path) {
					icon = data.markers_path + '/bed-markers/' + (place.length > 5 ? '5' : place.length) + '_beds_12.png';
				} else {
					icon = Res_i + '/w/hoods/hood-markers/' + (place.length > 100 ? '100+' : place.length) + '.png';
				}

				self.add_marker({
					lat: place[0].lat,
					lng: place[0].lng,
					icon: icon,
					bubble: {
						content: (place[0].name || place[0].display_name || place[0].street_address || 'Unknown building') + '<span class="legend">Click on marker for more info</span>'
					},
					label: {
						content: null
					},
					base_point: 'center',
					callbacks: {
						onClick: function onClick() {
							opts.open_blimp(place[0].url_popup);
						}
					}
				});

				num_of_markers++;
			}
		});

		if (num_of_markers > 0) {
			this.fit_markers();
		} else {
			this.center_map_in_ny();
		}

		(function () {
			this.fireEvent('ready');
		}).bind(this).delay(1000);
	},

	center_map_in_ny: function center_map_in_ny() {
		var lat = 40.7646;
		var lng = -73.9777;

		var center = new google.maps.LatLng(lat, lng);

		this.map.setCenter(center);
	},

	reset_map: function reset_map() {
		this.clear_markers();
		this.process_rpc();
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	}
});
'use strict';

/*
--- 
description: FED Process
authors: 
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var NhStatsHeatMap = new Class({
	Extends: HoodsHeatMap,

	draw_map: function draw_map() {
		var zoom = this.data.zoom || 13;

		this.map = new google.maps.Map(this._element, {

			zoom: zoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		this.map.setOptions({ styles: this.options.map_styles });

		this.add_heatmap_layer();
	},

	add_heatmap_layer: function add_heatmap_layer() {
		var self = this;
		var data = this.data;
		var new_data = {};
		var data_empty = true;

		Object.each(data.data, function (el) {
			// el.each(function(e){
			if (!new_data[el.building_id]) {
				new_data[el.building_id] = [];
			}

			if (el.display) {
				new_data[el.building_id].push(el);
				data_empty = false;
			}
			// });
		});

		this.data.data = new_data;

		var heatmapData = [];

		Object.each(new_data, function (el) {

			if (el[0]) {

				if (!self.in_new_york(el[0].lat, el[0].lng)) return;

				var obj = { location: new google.maps.LatLng(el[0].lat, el[0].lng), weight: el.length };
				heatmapData.push(obj);
			}
		});

		if (this.heatmap) this.heatmap.setMap(null);

		var heatmap = this.heatmap = new google.maps.visualization.HeatmapLayer({
			data: heatmapData,
			radius: data.radius ? data.radius : 20
		});

		heatmap.setMap(this.map);

		var lat = 0,
		    lng = 0,
		    num_of_points = 0;

		Object.each(new_data, function (el) {
			if (el.length > 0) {
				if (!self.in_new_york(el[0].lat, el[0].lng)) return;

				lat += el[0].lat.toFloat();
				lng += el[0].lng.toFloat();
				num_of_points++;
			}
		});

		if (num_of_points > 0) {
			lat = lat / num_of_points;
			lng = lng / num_of_points;
		} else {
			lat = 40.7646;
			lng = -73.9777;
		}

		var center = new google.maps.LatLng(lat, lng);

		this.map.setCenter(center);
		// this.change_gradient();
		this.change_opacity();

		(function () {
			this.fireEvent('ready');
		}).bind(this).delay(1000);
	},

	change_opacity: function change_opacity() {
		this.heatmap.setOptions({ opacity: this.heatmap.get('opacity') ? null : 0.7 });
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	}
});
'use strict';

var RegionSelector = new Class({
	Implements: [Options, Events],

	options: {
		style: 'light',
		dispose_on_click: false,
		follow_url: true
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this._element = _element;
		this.setOptions(options);
		this.build();
	},

	build: function build() {
		var self = this;
		var opts = this.options;
		var _map = this._element.getElement('.map') || new Element('.map').inject(this._element);

		this.map = new RegionsMap(_map, opts);

		this.map.addEvent('mapReady', function () {
			self.draw();
		});
	},

	draw: function draw() {
		var self = this;
		var map = this.map;
		var map_message = this._element.getElement('.map_message');

		this.fx_msg = new Fx.Morph(map_message);

		google.maps.event.addListener(map.map, 'center_changed', function () {
			if (map_message) self.hide_message(map_message);
		});

		google.maps.event.addListener(map.map, 'zoom_changed', this.hide_message);

		this.set_hoods();
	},

	hide_message: function hide_message(msg) {
		if (!this.fx_msg) return;

		this.fx_msg.start({
			opacity: 0
		}).chain(function () {
			msg.dispose();
		});

		this.fx_msg = null;
	},

	select_hood: function select_hood(selected, data) {
		if (this.options.dispose_on_click) {
			this._element.dispose();
		}

		this.fireEvent('hoodSelect', [selected, data]);

		var url = data.url;

		if (this.options.follow_url && url) {
			window.location = url;
		}
	},

	set_hoods: function set_hoods() {
		var _bounds = this._element.getElement('.hoods_bounds');
		if (!_bounds) return;

		var bounds;

		try {
			bounds = JSONMOO.decode(_bounds.get('html'), false);
		} catch (e) {
			return;
		}

		if (typeOf(bounds) == 'object') {
			Object.each(bounds, function (el) {
				if (el.active != false) {
					this.map.set_region(el.name, el.bounds, this.select_hood.bind(this, null, el), false, el);
				}
			}.bind(this));
		} else if (typeOf(bounds) == 'array') {
			bounds.each(function (el) {
				if (el.active != false) {
					this.map.set_region(el.name, el.bounds, this.select_hood.bind(this, null, el), false, el);
				}
			}.bind(this));
		}
	}
});
'use strict';

Page.Mhs = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		var _graph = document.getElement('.neighborhood_stats');

		if (!_graph) return;

		this.add_neighborhood_stats(_graph);
		this.show_in_neighborhood_stats();
	},

	add_neighborhood_stats: function add_neighborhood_stats(_cont) {

		var self = this;
		var _nh_stats = _cont;

		if (!_nh_stats) return;

		var _type_select = _nh_stats.getElement('.w_styled_select._type select');

		this.region_selector = new RegionSelector(_nh_stats.getElement('#region_selector'), {
			style: 'light',
			dispose_on_click: true,
			follow_url: false,
			onHoodSelect: function onHoodSelect(selected, data) {
				self.make_stat(data, _type_select);
			}
		});
	},

	make_stat: function make_stat(data, _type_select) {
		var _controllers = document.getElement('.neighborhood_stats .graph_controllers');
		var _cat = document.getElement('.neighborhood_stats .nh_categories');
		var nh_id, region_Id;

		if (data) {
			nh_id = data.id;
			region_Id = data.regionId;
		}

		var nh_stats = new NhStats(_controllers, {
			type: _type_select.getElement(':selected') || _type_select.getElement(':selected').getAttribute('value'),

			onNhSet: function onNhSet(_styled_select) {
				this.current_nh_id = nh_id;
			}
		});

		var _r = _cat.getElement('[data-region=' + region_Id + ']');
		if (_r) {
			_r.fireEvent('click');
		}

		var _summary_title = document.getElement('.w_neighborhoods ._type');

		_type_select.addEvent('change', function (_el) {
			nh_stats.type = _el.getAttribute('value');

			if (_summary_title) {
				var str = nh_stats.type == 3 ? 'Co-op Sales Summary' : 'Condo Sales Summary';
				_summary_title.set('html', str);
			}

			if (nh_stats._clicked_cat) {
				nh_stats._clicked_cat.fireEvent('click');
			}
		});
	},

	show_in_neighborhood_stats: function show_in_neighborhood_stats() {
		var crNhStatsCriteria = Cookie.read('crNhStatsCriteria');

		if (!crNhStatsCriteria) return;

		var _nh_stats_controller = document.getElement('.neighborhood_stats .graph_controllers');
		var _region_selector = document.getElement('.neighborhood_stats #region_selector');
		var _type_select = document.getElement('.neighborhood_stats .w_styled_select._type select');

		if (_region_selector) _region_selector.dispose();

		crNhStatsCriteria = JSONMOO.decode(crNhStatsCriteria);

		_nh_stats_controller.set('data-bed-id', crNhStatsCriteria.beds);

		var data = {
			id: crNhStatsCriteria.hood,
			regionId: crNhStatsCriteria.region
		};

		this.make_stat(data, _type_select);

		(function () {
			var _nh_stats_styled_select = document.getElement('.nh_precise .w_styled_select');
			var _nh_stats_styled_select_options = _nh_stats_styled_select.getElements('select option');

			_nh_stats_styled_select_options.each(function (_option, i) {
				if (_option.get('data-hood') === crNhStatsCriteria.hood) {
					_nh_stats_styled_select.getElements('li')[i].fireEvent('click');
				}
			});
		}).delay(100);

		(function () {
			var _nh_stats_currency_styled_select = document.getElement('.neighborhood_stats .w_styled_select.currency');
			var _nh_stats_currency_select = document.getElement('.neighborhood_stats .w_styled_select.currency select');

			if (_nh_stats_currency_select.getElement(':selected').get('value') !== crNhStatsCriteria.currency) {
				_nh_stats_currency_select.getElements('option').each(function (_option, i) {
					if (_option.get('value') === crNhStatsCriteria.currency) {
						_nh_stats_currency_styled_select.getElements('.option')[i].fireEvent('click');
					}
				});
			}

			var _nh_stats_type_styled_select = document.getElement('.neighborhood_stats .w_styled_select._type');
			var _nh_stats_type_select = document.getElement('.neighborhood_stats .w_styled_select._type select');

			if (_nh_stats_type_select.getElement(':selected').get('value') !== crNhStatsCriteria.type) {
				_nh_stats_type_styled_select.getElements('option').each(function (_option, i) {
					if (_option.get('value') === crNhStatsCriteria.type) {
						_nh_stats_type_styled_select.getElements('.option')[i].fireEvent('click');
					}
				});
			}
		}).delay(1000);

		// Make the value of the crNhStatsCriteria cookie empty after applying the criteria.
		Cookie.write('crNhStatsCriteria', '');
	}
});
//# sourceMappingURL=mhs.js.map
